const id_purch_recap = {
    "": "rekap tagihan pembelian",
    add: "tambah rekap tagihan pembelian",
    detail: "detail rekap tagihan pembelian",

    label: {
        no_recap_inv: "no rekap tagihan",
        download_inv: "unduh bukti tagihan",
    },

    error: {
        create: "Gagal membuat rekap tagihan pembelian.",
        edit: "Gagal mengubah rekap tagihan pembelian.",
    },

    success: {
        create: "Berhasil membuat rekap tagihan pembelian.",
        edit: "Berhasil mengubah rekap tagihan pembelian.",
    },
}

export default id_purch_recap;